module.exports = __webpack_public_path__ + "static/media/pagination-last.bfa919a6.svg";